import React from 'react';
// import { ErrorPage } from 'routes/errorPage';
import { TravelExpenseResults } from 'api/services/TravelExpenses';
import { Table } from '@landsvirkjun/react.common';
import { columns } from './TravelExpensesPreviewTableModels';
import { Spinner } from 'components/Spinner';
import { Alert, AlertIcon } from '@chakra-ui/react';

type TravelExpensesPreviewProps = {
  expenseData: TravelExpenseResults[];
  expensesError: boolean;
  isFetchingExpenses: boolean;
};

export const TravelExpensesPreview = ({
  expenseData,
  expensesError,
  isFetchingExpenses,
}: TravelExpensesPreviewProps): JSX.Element => {
  if (expensesError)
    return (
      <Alert status="error" variant="left-accent">
        <AlertIcon />
        Ekki gekk að sækja kostnaðarfærslur, villan er skráð, vinsamlegast
        reynið aftur síðar.
      </Alert>
    );
  const amountTotal = expenseData.reduce((sum, row) => {
    return sum + row.amount;
  }, 0);

  return isFetchingExpenses ? (
    <Spinner delay={300} isFixed={false} />
  ) : (
    <Table data={expenseData} columns={columns(amountTotal)} showFooter />
  );
};
